module.exports = __webpack_public_path__ + "static/media/filtro.4b0fdb9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/global/filtro.svg
// module id = 1209
// module chunks = 0